var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from "vuex";
import { Component, Prop } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import GlobalVue from "../../globalVue";
import OrderService from '../../api/OrderService';
import { EPurOrderStatus } from "../../enum/EStatus";
import { EBillType } from "../../enum/EBillType";
import BillSubTable from "../../components/bill/BillSubTable.vue";
import { toDetail } from "../../helper/util";
import _ from 'lodash';
var PurOrderTable = (function (_super) {
    __extends(PurOrderTable, _super);
    function PurOrderTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = 300;
        _this.eBillType = EBillType;
        _this.splitStatusMap = {
            yes: 1,
            no: 0
        };
        _this.thirdPartyStatus = true;
        _this.dialogVisible = false;
        _this.dialogTableData = Array;
        _this.purOrderStatus = EPurOrderStatus;
        _this.refresh = true;
        return _this;
    }
    Object.defineProperty(PurOrderTable.prototype, "Columns", {
        get: function () {
            var start = [], end = [], cols = [];
            var center = [
                { prop: "order_code", label: "订货单号", align: 'left', sortable: false, width: "200", toPageType: false },
                { prop: "from_system_name", label: "单据来源", sortable: false, width: "150", toPageType: false }
            ];
            if (this.status == EPurOrderStatus.SumAndSplit && this.openedCodeData.isOpenSorting) {
                center.push({ prop: "is_sorting", label: "是否分单", sortable: "custom", width: "150", toPageType: false, isTransform: true });
            }
            if (this.openedCodeData.isOpenMultOrg) {
                center.push({ prop: "organ_name", label: "销售机构", sortable: false, width: "150", toPageType: false });
            }
            center = center.concat([
                { prop: "customer", label: "客户", sortable: false, minWidth: "180", toPageType: false },
                { prop: "shop_name", label: "订货门店", minWidth: "180", sortable: false, toPageType: false },
                { prop: "depot_name", label: "订货仓库", minWidth: "180", sortable: false, toPageType: false },
                { prop: "item_num", label: "品项", sortable: "custom", width: "80", toPageType: false },
                { prop: "order_money", label: "金额", sortable: "custom", width: "80", toPageType: false }
            ]);
            switch (this.status) {
                case EPurOrderStatus.Bconfirm:
                    start = [{ prop: "order_arriveddate", label: "到货日期", sortable: "custom", width: "120", toPageType: false }];
                    end = [{ prop: "order_ctime", label: "订货日期", sortable: "custom", width: "120", toPageType: false }];
                    break;
                case EPurOrderStatus.ToAudit:
                    start = [{ prop: "order_arriveddate", label: "到货日期", sortable: "custom", width: "120", toPageType: false }];
                    end = [{ prop: "order_confirmdate", label: "确认日期", sortable: "custom", width: "120", toPageType: false }];
                    break;
                case EPurOrderStatus.Shipped:
                    start = [{ prop: "delivery_date", label: "送货日期", sortable: "custom", width: "120", toPageType: false }];
                    end = [{ prop: "delivery_order_codes", label: "送货单号", sortable: false, width: "150", toPageType: EBillType.Deliver, billName: "delivery_order_code", toBillId: "delivery_order_id" },
                        { prop: "order_ctime", label: "订货日期", sortable: "custom", width: "120", toPageType: false },
                        { prop: "order_arriveddate", label: "到货日期", sortable: "custom", width: "120", toPageType: false }];
                    break;
                case EPurOrderStatus.Complete:
                    start = [{ prop: "warehouse_receipt_date", label: "审核日期", sortable: "custom", width: "120", toPageType: false }];
                    end = [{ prop: "warehouse_receipt_codes", label: "入库单号", sortable: false, width: "150", toPageType: EBillType.PurIn, billName: "warehouse_receipt_code", toBillId: "warehouse_receipt_id" },
                        { prop: "delivery_order_codes", label: "送货单号", sortable: false, width: "150", toPageType: EBillType.Deliver, billName: "delivery_order_code", toBillId: "delivery_order_id" },
                        { prop: "delivery_date", label: "送货日期", sortable: "custom", width: "120", toPageType: false },
                        { prop: "order_ctime", label: "订货日期", sortable: "custom", width: "120", toPageType: false },
                        { prop: "order_arriveddate", label: "到货日期", sortable: "custom", width: "120", toPageType: false }];
                    break;
                case EPurOrderStatus.Invalid:
                    start = [{ prop: "order_canceldate", label: "撤销日期", sortable: "custom", width: "120", toPageType: false }];
                    end = [{ prop: "delivery_order_codes", label: "送货单号", sortable: false, width: "150", toPageType: EBillType.Deliver, billName: "delivery_order_code", toBillId: "delivery_order_id" },
                        { prop: "delivery_date", label: "送货日期", sortable: "custom", width: "120", toPageType: false },
                        { prop: "order_ctime", label: "订货日期", sortable: "custom", width: "120", toPageType: false },
                        { prop: "order_arriveddate", label: "到货日期", sortable: "custom", width: "120", toPageType: false }];
                    break;
                case EPurOrderStatus.Bship || EPurOrderStatus.SumAndSplit:
                    start = [
                        { prop: "order_arriveddate", label: "到货日期", sortable: "custom", width: "120", toPageType: false }
                    ];
                    end = [
                        { prop: "order_confirmdate", label: "确认日期", sortable: "custom", width: "120", toPageType: false },
                        { prop: "order_ctime", label: "订货日期", sortable: "custom", width: "120", toPageType: false },
                    ];
                    break;
                default:
                    break;
            }
            ;
            cols = start.concat(center).concat(end);
            return cols;
        },
        enumerable: true,
        configurable: true
    });
    PurOrderTable.prototype.created = function () {
        this.service = OrderService.getInstance();
    };
    PurOrderTable.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 270;
        }, 300);
    };
    PurOrderTable.prototype.expandChange = function (row, expandedRows) {
        var _this = this;
        if (expandedRows.length == 0) {
            return;
        }
        var params = {
            order_id: row.order_id
        };
        var index = this.listData.indexOf(row);
        this.service.getListGoods(params).then(function (res) {
            _.forEach(res.data.data, function (item) {
                item.amount = item.order_detail_amount;
                item.order_sup_status = row.order_sup_status;
                item.logistics_type = row.logistics_type;
            });
            var listGoods = res.data.data;
            listGoods.push({ isBtn: true });
            GlobalVue.$set(_this.listData[index], 'listGoods', listGoods);
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    PurOrderTable.prototype.selectionChange = function (val) {
        this.$emit('selectionChange', val);
    };
    PurOrderTable.prototype.lookDetail = function (row) {
        this.$emit('lookDetail', row);
    };
    PurOrderTable.prototype.discard = function (id) {
        var _this = this;
        var msg = '确定要废弃选中的订单吗？';
        this.$confirm(msg, "提示", {
            cancelButtonText: "否",
            confirmButtonText: "是",
            dangerouslyUseHTMLString: true
        }).then(function (res) {
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service.cancel({
                ids: id
            }).then(function (res) {
                loadingInstance.close();
                if (res.data.code == 76) {
                    _this.$message.error(res.data.msg);
                }
                else {
                    _this.$message.success(res.data.msg || "废弃成功");
                }
                _this.$emit('discard', id);
            }).catch(function (err) {
                loadingInstance.close();
                _this.$message.error(err.msg || err.message);
            });
        }).catch(function () { });
    };
    PurOrderTable.prototype.deliver = function (row) {
        this.$emit("toShip", row);
    };
    PurOrderTable.prototype.confirm = function (row) {
        this.$emit("confirm", row);
    };
    PurOrderTable.prototype.sortChange = function (pager) {
        this.$emit('sortChange', pager);
    };
    PurOrderTable.prototype.toPage = function (type, id) {
        toDetail(type, id);
    };
    PurOrderTable.prototype.toPurIn = function (row) {
        toDetail(EBillType.PurIn, row.warehouse_receipt_id);
    };
    PurOrderTable.prototype.toDeliver = function (row) {
        toDetail(EBillType.Deliver, row.delivery_order_id);
    };
    PurOrderTable.prototype.modify = function (row) {
        this.$emit('modify', row);
    };
    PurOrderTable.prototype.copyData = function (row) {
        this.$emit('copyData', row);
    };
    PurOrderTable.prototype.showShippedCodeDialog = function (data, toPageType) {
        this.dialogVisible = true;
        this.dialogTableData = data;
        this.dialogTableData.forEach(function (item, index) {
            item["index"] = index + 1;
            item["toPageType"] = toPageType;
            item["label"] = toPageType == 2 ? "入库单号" : "送货单号";
            item["datail"] = toPageType == 2 ? item.warehouse_receipt_code : item.delivery_order_code;
        });
    };
    PurOrderTable.prototype.columnClick = function (row) {
        if (row.toPageType) {
            this.dialogVisible = false;
            toDetail(row.toPageType, row.toPageType == 2 ? row.warehouse_receipt_id : row.delivery_order_id);
        }
    };
    __decorate([
        Prop({
            default: [],
            type: Array
        })
    ], PurOrderTable.prototype, "listData", void 0);
    __decorate([
        Prop({
            default: '0',
            type: String
        })
    ], PurOrderTable.prototype, "status", void 0);
    PurOrderTable = __decorate([
        Component({
            components: {
                BillSubTable: BillSubTable
            },
            computed: __assign({}, mapGetters({
                serviceData: 'serviceData',
                serviceDataList: 'serviceDataList',
                openedCodeData: 'openedCodeData',
                ediStatus: 'ediStatus'
            }))
        })
    ], PurOrderTable);
    return PurOrderTable;
}(Vue));
export default PurOrderTable;
